<div
  data-testid="editorial-category"
  class="nordic-blue-900-text text-icon-primary inline-block"
  [attr.id]="segmentId()"
>
  <h2 class="editorial-category-title mr-small-b">{{ editorialCategory().teaserTitle }}</h2>
  @for (q of items(); track q.contentId) {
    <div class="editorial-category-links font-body-medium">
      @if (!q.isShowAllLink) {
        <div class="mr-small-y">
          <a [finLink]="q.url" class="no-decoration nordic-blue-900-text text-icon-primary">{{ q.teaserTitle }}</a>
        </div>
      } @else {
        <div class="mr-small-t mr-large-b font-body-medium-bold text-icon-primary text-icon-primary-hover">
          <a [finLink]="q.url" class="no-decoration nordic-blue-900-text text-icon-primary"
            >{{ q.teaserTitle }}
            <fcom-icon class="editorial-category-link-icon icon-small" [name]="SvgLibraryIcon.ARROW_RIGHT"
          /></a>
        </div>
      }
    </div>
  }
</div>
